import React, { Component } from "react";
import { connect } from "react-redux";
import TripList from "./components/TripList";
import GreyBackgroundPage from "../../components/GreyBackgroundPage";
import NoResults from "./components/NoResults";
import {
  selectTrip,
  fetchReturningTrips,
  fetchInstallmentInfo
} from "../../data/trips/actions";
import { getLandingPageFormValues } from "../../data/landingPageForm/selectors";
import LoadingFlightsPage from "../../components/LoadingFlightsPage";
// import { getTrips } from "../../data/trips/selectors";
import { Route } from "react-router-dom";

const PageContent = ({
  onTripSelect,
  trips,
  stepperText,
  tripSegmentHeader
}) => (
  <GreyBackgroundPage stepperText={stepperText}>
    <TripList
      trips={trips}
      onTripSelect={onTripSelect}
      tripSegmentHeader={tripSegmentHeader}
    />
  </GreyBackgroundPage>
);

class SearchResultPage extends Component {
  render() {
    const {
      departingTrips,
      isRoundTrip,
      fetchingTrips,
      returningTrips,
      onTripSelectDeparting,
      onTripSelectReturning,
      error
    } = this.props;
    const stepperTextDeparting = `Step ${
      isRoundTrip ? "1 of 3" : "1 of 2"
    }: Select Departing Trip`;
    const stepperTextArriving = "Step 2 of 3: Select Returning Trip";
    const tripSegmentHeaderDeparting = "Departing Trip";
    const tripSegmentHeaderReturning = "Returning Trip";
    const genericErrorMessage =
      "We did not find a trip with your search inputs.";

    // Construct page to display
    let renderPage;

    if (error) {
      // In some wierd cases, e.g. when state.trips.error = "Air.FlightContract: Air inventory feed error.",
      // PPN may have returned state.trips.departingTrips and state.trips.returningTrips. We want to prevent
      // the wierdness that occurs from rendering "/search-results/returning", because picking a flight on that
      // page, in order to enter /review-order, will keep returning that error, looping the user and preventing
      // the user from moving into /review-order. We want to catch any errors returned from PPN, whether or not
      // we have departingTrips/returningTrips data.
      renderPage = <NoResults error={genericErrorMessage} />;
    } else if (departingTrips || returningTrips || fetchingTrips) {
      renderPage = (
        <div>
          <LoadingFlightsPage isHidden={!fetchingTrips} />
          <Route
            exact
            path={"/search-results"}
            component={() => (
              <PageContent
                tripSegmentHeader={tripSegmentHeaderDeparting}
                stepperText={stepperTextDeparting}
                onTripSelect={onTripSelectDeparting}
                trips={departingTrips}
              />
            )}
          />
          <Route
            path={"/search-results/returning"}
            component={() => (
              <PageContent
                tripSegmentHeader={tripSegmentHeaderReturning}
                stepperText={stepperTextArriving}
                onTripSelect={onTripSelectReturning}
                trips={returningTrips}
              />
            )}
          />
        </div>
      );
    } else {
      renderPage = <NoResults error={genericErrorMessage} />;
    }

    return renderPage;
  }
}

function mapStateToProps(state) {
  const { isRoundTrip, departDate } = getLandingPageFormValues(state);
  return {
    error: state.trips.error,
    fetchingTrips: state.trips.fetchingTrips,
    isRoundTrip,
    departDate,
    departingTrips: state.trips.departingTrips,
    returningTrips: state.trips.returningTrips
  };
}

/**
 * Using mergeProps() instead of mapDispatchToProps() because access to stateProp, isRoundTrip,
 * is needed and it will be unavailable if mapDispatchToProps() was used
 */
function mergeProps(stateProps, dispatchProps, ownProps) {
  const { isRoundTrip, departDate } = stateProps;
  const { dispatch } = dispatchProps;
  const { history } = ownProps;

  // const departureDate = "2018-06-15" // TODO get from props

  return {
    ...ownProps, //provides parent props that have nothing to do with redux-form (in this case, only react-router's history obj).
    ...stateProps, // provides result from mapStateToProps e.g. 'fetchingTrips' to component
    onTripSelectDeparting: ({ tripId, ppnContractBundle, ppnReturnBundle }) => {
      dispatch(selectTrip({ tripId, tripType: "DEPARTING" }));

      // If Roundtrip, redirect to /search-results/returning and fetch trips. Else nav to /review-order
      if (isRoundTrip) {
        dispatch(fetchReturningTrips({ history, ppnReturnBundle, departDate }));
      } else {
        dispatch(
          fetchInstallmentInfo({ history, ppnContractBundle, departDate })
        );
      }
    },
    onTripSelectReturning: ({ tripId, ppnContractBundle }) => {
      dispatch(selectTrip({ tripId }));
      dispatch(
        fetchInstallmentInfo({ history, ppnContractBundle, departDate })
      );
    }
  };
}
export default connect(
  mapStateToProps,
  null,
  mergeProps
)(SearchResultPage);



// WEBPACK FOOTER //
// ./src/scenes/SearchResultsPage/index.js